import { render, staticRenderFns } from "./ProjectCompletionRoom.vue?vue&type=template&id=6bef67ce&"
import script from "./ProjectCompletionRoom.vue?vue&type=script&lang=js&"
export * from "./ProjectCompletionRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports